import addStyleObjectToHead from './addStyleObjectToHead';
import getCustomStyling from './addCustomStyling';

/**
 * Get all the style objects from the current Document and add it to the download document.
 */
const addStyleObjectsToDocument = (newDocument:HTMLDocument): void => {
  const customStyling = getCustomStyling();
  addStyleObjectToHead(newDocument, customStyling);
};

export default addStyleObjectsToDocument;
